import { Component } from '@angular/core'

@Component({
  standalone: false,
  selector: 'footer-only-layout',
  templateUrl: 'footer-only-layout.component.html',
  styleUrls: ['./footer-only-layout.component.scss'],
})
export class FooterOnlyLayoutComponent {}
